import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './Team.css';

const Team = () => {
    const teamMembers = [
        {
            name: 'Dr. Marie Dubois',
            specialty: 'Chirurgien-Dentiste - Directrice',
            image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
            experience: '15 ans d\'expérience',
            specializations: ['Chirurgie implantaire', 'Esthétique dentaire', 'Parodontologie'],
            education: 'Université Paris Descartes',
            languages: ['Français', 'Anglais', 'Espagnol']
        },
        {
            name: 'Dr. Pierre Martin',
            specialty: 'Orthodontiste',
            image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
            experience: '12 ans d\'expérience',
            specializations: ['Orthodontie adulte', 'Invisalign', 'Orthodontie linguale'],
            education: 'Université Lyon 1',
            languages: ['Français', 'Anglais']
        },
        {
            name: 'Dr. Sophie Leroy',
            specialty: 'Dentiste Pédiatrique',
            image: 'https://www.chl.lu/sites/default/files/styles/contact_photo/public/Dr-Sophie-Servais-001.jpg?itok=7BEodJIi',
            experience: '8 ans d\'expérience',
            specializations: ['Dentisterie pédiatrique', 'Sédation consciente', 'Prévention'],
            education: 'Université Bordeaux',
            languages: ['Français', 'Anglais', 'Italien']
        }
    ];

    return (
        <section id="team" className="team-section">
            <Container>
                <Row>
                    <Col lg={8} className="mx-auto text-center">
                        <div className="section-header">
                            <span className="section-badge">Notre Équipe</span>
                            <h2 className="section-title">
                                Des experts passionnés à votre service
                            </h2>
                            <p className="section-subtitle">
                                Rencontrez notre équipe de professionnels dévoués, formés aux dernières 
                                techniques et technologies dentaires.
                            </p>
                        </div>
                    </Col>
                </Row>

                <Row className="g-4">
                    {teamMembers.map((member, index) => (
                        <Col lg={4} md={6} key={index}>
                            <Card className="team-card h-100">
                                <div className="team-image-wrapper">
                                    <img 
                                        src={member.image} 
                                        alt={member.name}
                                        className="team-image"
                                    />
                                    <div className="team-overlay">
                                        <div className="social-links">
                                            <a href="#" className="social-link">
                                                <i className="fab fa-linkedin"></i>
                                            </a>
                                            <a href="#" className="social-link">
                                                <i className="fas fa-envelope"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                
                                <Card.Body>
                                    <h4 className="team-name">{member.name}</h4>
                                    <p className="team-specialty">{member.specialty}</p>
                                    <div className="team-experience">
                                        <i className="fas fa-clock me-2"></i>
                                        {member.experience}
                                    </div>
                                    
                                    <div className="team-details">
                                        <div className="detail-item">
                                            <strong>Spécialisations :</strong>
                                            <ul className="specializations-list">
                                                {member.specializations.map((spec, idx) => (
                                                    <li key={idx}>{spec}</li>
                                                ))}
                                            </ul>
                                        </div>
                                        
                                        <div className="detail-item">
                                            <strong>Formation :</strong>
                                            <p>{member.education}</p>
                                        </div>
                                        
                                        <div className="detail-item">
                                            <strong>Langues :</strong>
                                            <div className="languages">
                                                {member.languages.map((lang, idx) => (
                                                    <span key={idx} className="language-tag">
                                                        {lang}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default Team;